import { useMemo } from 'react';
import { useBaseFilter, useFilter } from '../../../hooks/useFilter';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getSelectedFilterItems } from '../../../store/common/selectors';
import { getMembers, getSelectedLocationId } from '../../../store/team/selectors';

export function useTeamFilters() {
  const { baseFilters } = useBaseFilter();
  const {
    filterByPermissions,
    filterByDepartments,
    filterByPositions,
    filterByLocations,
  } = useFilter();

  const selectedFilterItems = useAppSelector(getSelectedFilterItems);
  const selectedLocationId = useAppSelector(getSelectedLocationId);

  const members = useAppSelector(getMembers);

  const getTeamByFilters = useMemo(() => {
    let filteredTeam = members;

    if (selectedFilterItems.role?.length) {
      filteredTeam = filterByPermissions(members);
    }

    if (selectedFilterItems.department?.length) {
      filteredTeam = filterByDepartments(members);
    }

    if (selectedFilterItems.position?.length) {
      filteredTeam = filterByPositions(members);
    }

    if (selectedFilterItems.location?.length) {
      filteredTeam = filterByLocations(members);
    }

    if (selectedLocationId > 0) {
      filteredTeam = filteredTeam.filter((member) => member.locations.some((location) => location.id === selectedLocationId));
    }

    return filteredTeam;
  }, [selectedFilterItems, members, selectedLocationId]);

  return {
    teamFilterItems: baseFilters,
    getTeamByFilters,
  };
}
